<template lang="pug">
    div#rnd-mindcore-view
        mainHeader
        div.box
            div.has-text-centered
                strong.title MindCore's R&D
            hr

            div.box.is-lighter
                div.has-text-left
                    router-link(:to="nyx_link")
                        strong.title Nyx
                hr
                div.columns
                    div.column.is-4
                        router-link(:to="nyx_link")
                            img(:src="`${baseUrl}img/Nyx.jpg`")
                    div.column.has-text-justified
                        p Τα τελευταία χρόνια η εταιρεία μας ερευνά και αναπτύσσει τεχνολογίες στον χώρο των UAVS (Drones) και του security και έχει καταλήξει σε ένα πάντρεμα αυτών των δύο με το σύστημα “Nyx”. Το Nyx είναι ένα πλήρως αυτοματοποιημένο σύστημα περιπολίας και επίβλεψης χώρων με την χρήση drone. Σχεδιάζεται και υλοποιείται εξολοκλήρου από την MindCore τόσο στο software όσο και στο hardware.
                        br
                        router-link(:to="nyx_link")
                            a.button
                                strong Read more ...
                        
                //- div
                    router-link(:to="nyx_link")
                            a.button.is-white
                            strong Read more ...
            hr

            div.box.is-lighter
                div.has-text-left
                    router-link(:to="iris_link")
                        strong.title Iris
                hr
                div.columns
                    div.column.is-4
                        router-link(:to="iris_link")
                            img(:src="`${baseUrl}img/DSC_0056.jpg`")
                    div.column.has-text-justified
                        p Σύστημα ανίχνευσης πυρκαγιάς με μη επανδρωμένο αεροσκάφος. Στόχος του συγκεκριμένου προγράμματος είναι να συμβάλλει καθοριστικά στην έγκαιρη ανίχνευση των εστιών φωτιάς με αποδοτικό, αλλά συνάμα και οικονομικό τρόπο.
                        br
                        router-link(:to="iris_link")
                            a.button
                                strong Read more ... 
                //- div
                    router-link(:to="iris_link")
                            a.button.is-white
                            strong Read more ...
            //- hr 

                
        Footer

</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'rnd-as-a-service',
  components: {
    MainHeader,
    Footer
  },
  data: function () {
    return {
        baseUrl: process.env.BASE_URL,
        nyx_link: '/rnd/mindcore/nyx',
        iris_link: '/rnd/mindcore/iris',
    };
  }
}
</script>

<style scoped>
/* p {
    position: relative;
    top: 50%;
    transform: translateY(-50%); 
} */

/* .down {
    position: relative;
}

.down-content {
    position: absolute;
    bottom: 0;
} */

a {
    background-color: #F0F0F0;
}

.button {
    border-style: none;
    padding-left: 0;
}

.lighter {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;

}

.box {
    background-color: #E8E8E8;
}

.is-lighter {
    background-color: #F0F0F0;
}

</style>